import { render } from "./ToolboxTitle.vue?vue&type=template&id=3ff104f2"
import script from "./ToolboxTitle.vue?vue&type=script&lang=js"
export * from "./ToolboxTitle.vue?vue&type=script&lang=js"

import "./ToolboxTitle.vue?vue&type=style&index=0&id=3ff104f2&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.18.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__